/**
 * The section each `(app)` route belongs to on web, by its URL's first segment (web URLs carry no
 * route groups). The header shows the name beside the account avatar.
 */
const WEB_SECTION_LABELS: Partial<Record<string, string>> = {
  browse: "Browse",
  changelog: "Changelog",
  collections: "Collections",
  cookbook: "Cookbook",
  decks: "Deck",
  idioms: "Idioms",
  learn: "Learn",
  profile: "Profile",
  // The header's search button opens Search as one of Browse's tabs.
  search: "Browse",
  settings: "Settings",
  stats: "Stats",
};

function firstPathSegment(pathname: string): string {
  return pathname.split("/")[1] ?? "";
}

/** The current section's name, or `null` off the app's sections (the avatar then stands alone). */
export function getWebSectionLabel(pathname: string): string | null {
  return WEB_SECTION_LABELS[firstPathSegment(pathname)] ?? null;
}

/** Browse's categories and Search, which share Browse's sidebar on web. */
export function isWebBrowseSection(pathname: string): boolean {
  const segment = firstPathSegment(pathname);
  return segment === "browse" || segment === "search";
}

export function isWebSearchPath(pathname: string): boolean {
  return firstPathSegment(pathname) === "search";
}
